import layerAdder from './layerAdder';
import creator from './elementCreator';
import mapToolPlugin from './plugins/mapToolPlugin.js';
import contextFns from './plugins/contextMenuPlugin.js';
import global from './globals';

import {Map, View} from 'ol';
import Control from 'ol/control/Control.js';
import proj4 from 'proj4';
import {register} from 'ol/proj/proj4.js';
import {get as getProjection} from 'ol/proj.js';
import {defaults} from 'ol/interaction/defaults';
import Select from 'ol/interaction/Select.js';
import {pointerMove, singleClick} from 'ol/events/condition.js';
import MousePosition from 'ol/control/MousePosition.js';
import ScaleLine from 'ol/control/ScaleLine.js';
import Zoom from 'ol/control/Zoom.js'; 
import {format} from 'ol/coordinate.js';
import Style from 'ol/style/Style.js';
import Stroke from 'ol/style/Stroke.js';
import Fill from 'ol/style/Fill.js';
import Text from 'ol/style/Text.js';
import Circle from 'ol/style/Circle.js';

"use strict";
var privateFns, mapInteractions, toolClickFns, functionality;
let toolChoice = {};
functionality = {
	removeHoverCssClasses: function () {
		try {
			Object.keys(document.styleSheets).forEach(function (sheetIndex) {
				var sheet = document.styleSheets[sheetIndex];
				if (sheet.href) {
					if (sheet.href.indexOf("main.css") >= 0) {
						functionality.removeClassByType(":hover", sheet);
					} else if (sheet.href.indexOf("ol.css") >= 0) {
						functionality.removeClassByType(":hover", sheet);
					}
				}
			});
		} catch (ex) {
			console.log(ex);
		}
	},
	removeClassByType: function (type, sheet) {
		Object.keys(sheet.rules).forEach(function (ruleIndex) {
			if (sheet.rules[ruleIndex]) {
				if (sheet.rules[ruleIndex].selectorText) {
					if (sheet.rules[ruleIndex].selectorText.match(type)) {
						sheet.deleteRule(ruleIndex);
					}
				}
			}
		});
	},
	addMobileEvents: function () {
	},
},
mapInteractions = {
	addFeatureHoverInteraction: function (featureClick, conf) {
		var layers = mapInteractions.getFeatureInfoLayers();
		let selected = null;
		/** WebGL hover **/
		global.map.on('pointermove', function (ev) {
			if (selected !== null) {	
				selected.set('hover', 0);
				selected = null;
			}

			global.map.forEachFeatureAtPixel(ev.pixel, function (feature) {
				feature.set('hover', 1);
				selected = feature;
				return true;
			});
		});
		/** Hover **/
		var interaction = new Select({
			condition: pointerMove,
			layers: layers,
			style: mapInteractions.selectFeatureStyle("rgba(110, 110, 110, 0.8)")
		});
		global.map.addInteraction(interaction);
		interaction.set("interactionId", "featurehover");
		interaction.on("select", function (e) {
			if (global.isTouchDevice) {
				this.getFeatures().clear();
				this.setActive(false);
			} else {
				if (e.selected.length > 0) {
					var coordinate = e.mapBrowserEvent.coordinate;
					coordinate[0] = coordinate[0] - 15;
					coordinate[1] = coordinate[1] - 15;
					
					global.map.getOverlays().getArray()[0].setPosition(coordinate);
					var html = "";
					if (e.selected[0].get("features")) {
						layers.forEach(function(lyr){
							if(lyr.getSource().hasFeature(e.selected[0]) && conf && conf[lyr.values_.layerId]){
								html = mapInteractions.getClusterHoverInfo(e.selected[0], conf[lyr.values_.layerId]);
							}
						})
					} else if(conf){
						html = mapInteractions.getHoverInfo(e.selected[0], conf[e.target.getFeatures().C[0].get("layerName")]);
					}else{
						html = "";
					}
					var target = $("#popup");
					target.html(html);
					target.show();
					if (featureClick) {
						target.click(function () {
							contextFns.showFeatureInfoForType(e, conf);
							global.map.getOverlays().getArray()[0].setPosition(undefined);
						});
					}
				} else {
					global.map.getOverlays().getArray()[0].setPosition(undefined);
				}
			}
		});
	},
	getFeatureInfoLayers: function () {
		var layers = [];
		global.forAllLayers(global.map, function (layer) {
			if (layer.get("featureInfo")) {
				layers.push(layer);
			}
		});
		return layers;
	},
	getClusterHoverInfo: function (cluster, conf) {
		var html = creator.createDiv({css: "skjenkePunkt" });
		cluster.get("features").some(function (f, idx) {
			var done = false;
			html.append(mapInteractions.getHoverInfo(f, conf));
			if (idx === 2) {
				done = true;
			}
			return done;
		});
		return html;
	},
	getHoverInfo: function (f, layout) {
		if(layout){				
			var wrapper = creator.createSection({});
			wrapper.style.backgroundColor = "rgba(255,255,255,0.5)";
			if(layout.header){
				var header = f.get(layout.header) ? f.get(layout.header) : layout.header;
				wrapper.append(creator.createH3({text: header}));
			}
			if(layout.cssClass){				
				wrapper.className = layout.cssClass;
			}
			layout.layout.forEach(function(el){
				if(el.type === "header"){
					wrapper.appendChild(creator.createH5({
						text: f.get(el.value),
						css: "menuPadding"
					}));
				}else if(el.type === "paragraph"){
					var inner = f.get(el.prefix) ? f.get(el.prefix) : el.prefix ? el.prefix : "";
					inner += f.get(el.value) ? f.get(el.value) : el.alt ? el.alt : el.value;
					inner += f.get(el.suffix) ? f.get(el.suffix) : el.suffix ? el.suffix : "";
					wrapper.append(creator.createParagraph({
						text: inner
					}));
				}else if(el.type === "link"){
					var lenke = creator.createDiv({});
					var lenketekst = f.get(el.text) ? f.get(el.text) : el.text;
					lenke.innerHTML = lenketekst + "<i class='icon-new-window'></i>";
					lenke.className = "looklike-btn-link link-div";
					var url = el.url ? el.url : f.get(el.href) ? f.get(el.href) : false;
					if(url){
						url += f.get(el.urlParam) ? f.get(el.urlParam) : el.urlParam ? el.urlParam : "";
						url += el.postfix ? el.postfix : "";
						$(lenke).click(privateFns.sakInfoOnClick(url));
						wrapper.append(lenke);						
					}
				}
			});
			return wrapper;
		}
		return "";
	},
	trimPopupContent: function (text, limit) {
		if (text && text.length > limit) {
			text = text.substr(0, limit) + "...";
		}
		return text;
	},
	selectFeatureStyle: function (color) {
		return function (feature) {
			var radius = 0;
			if (feature.get("features")) {
				radius = layerAdder.setRadiusForSize(feature.get("features").length);
			} else {
				radius = 7;
			}
			var style = global.selectStyleCache[radius + color];

			if (!style) {
				style = [new Style({
					fill: new Fill({
						color: color
					}),
					image: new Circle({
						radius: radius,
						fill: new Fill({
							color: color
						}),
						snapToPixel: true
					})
				})];
				global.selectStyleCache[radius + color] = style;
			}
			return style;
		};
	},
	addFeatureClickInteraction: function (conf) {
		var layers = mapInteractions.getFeatureInfoLayers();
		var interaction = new Select({
			condition: singleClick,
			layers: layers,
			style: mapInteractions.selectFeatureStyle("rgba(80, 80, 80, 0.8)")
		});
		global.map.addInteraction(interaction);
		interaction.set("interactionId", "featureclick");
		interaction.on("select", function (e) {
			global.map.getOverlays().getArray()[0].setPosition(undefined);
			if (e.selected.length > 0) {
				contextFns.showFeatureInfoForType(e, conf);
			} else {
				/* Lukker kontekstmeny nivå 3 */
				$(".featureinfo-details").removeClass("aside-show");
			}
		});
	},        
	addDrawLayer: function () {
		var style = new Style({
			stroke: new Stroke({
				color: "#ff0000",
				width: 3
			}),
			image: new Circle({
				radius: 5,
				stroke: new Stroke({
					color: "rgba(255, 0, 0, 1)"
				}),
				fill: new Fill({
					color: "rgba(255, 255, 255, 0.2)"
				})
			})
		});
		var source = new ol.source.Vector();
		var vector = new ol.layer.Vector({
			title: "sketchLayer",
			source: source,
			style: style
		});
		global.map.addLayer(vector);
		return source;
	},
	addMeasureLayer: function () {
		var vstyleCache = {};
		var source = new ol.source.Vector();
		var layer = new ol.layer.Vector({
			title: "drawLayer",
			source: source,
			style: function (feature) {
				var size = 0;
				if (feature.getGeometry().getType() === "LineString") {
					size = mapInteractions.getMeasureLength(feature);
				} else {
					size = mapInteractions.getMeasureArea(feature);
				}
				var style = vstyleCache[size];
				if (!style) {
					style = [new Style({
						fill: new Fill({
							color: "rgba(255, 255, 255, 0.2)"
						}),
						stroke: new Stroke({
							color: "#0000ff",
							width: 3
						}),
						text: new Text({
							scale: 2.0,
							text: size.toString(),
							fill: new Fill({
								color: "#fff"
							}),
							stroke: new Stroke({
								color: "#00f",
								width: 2
							}),
							textAlign: "end"
						})
					})];
					vstyleCache[size] = style;
				}
				return style;
			}
		});
		global.map.addLayer(layer);
		return source;
	},
	addMapToolPlugin: function (tool) {
		if(!(tool.touchSensitive && global.isTouchDevice)){
			var btn = creator.createButton({
				id: tool.id,
				css: "map-tool-btn " + tool.className,
				title: tool.toolTip,
			});
			var text = creator.createSpan({css: "text-view", text: tool.buttonText});
			
			let sideBtn = btn.cloneNode(true);
			sideBtn.appendChild(text);
			sideBtn.id = sideBtn.id + "-side";
			sideBtn.value = btn.id;
			
			if(tool.register){
				tool.register(mapToolPlugin.registerPlugin, function(){
					if (typeof tool.onclick === "function") {
						btn.addEventListener('click', function(e){
							tool.onclick(e, tool.parameters);
						});
						sideBtn.addEventListener('click', function(e){
							tool.onclick(e, tool.parameters);
						});
					} else {
						btn.addEventListener('click', function(e){
							mapToolPlugin.toolClickFns[tool.onclick](e, tool.parameters);
						});
						sideBtn.addEventListener('click', function(e){
							mapToolPlugin.toolClickFns[tool.onclick](e, tool.parameters);
						});
					}
				});
			}else{		
				if (typeof tool.onclick === "function") {
					btn.onclick = tool.onclick;
					sideBtn.onclick = tool.onclick;
				} else {
					btn.onclick = mapToolPlugin.toolClickFns[tool.onclick];
					sideBtn.onclick = mapToolPlugin.toolClickFns[tool.onclick];
				}
			}
			if(tool.deactivate){
				btn.deactivate = tool.deactivate;
			}
			var icon;
			if (tool.iconType === "icon") {
				icon = creator.createIcon({css: tool.icon + " map-tool-btn-styling"});
			} else if (tool.iconType === "img") {
				icon = creator.createIcon({css: " map-tool-btn-styling", src: tool.icon});
			} else if (tool.iconType === "text") {
				icon = creator.createSpan({text: tool.icon, css: "map-tool-btn-styling"});
			}else{
				icon = creator.createIcon({});
			};
			if(tool.toolHelp){
				privateFns.createToolHelp(tool);
			}
			
			let toolCheckbox = creator.createInput({type: "checkbox", css: "toolCheckbox"});
			toolCheckbox.onclick = function(el){
				if(el.target.checked){
					$("#"+$(el.target).parent()[0].value).show();
					toolChoice[btn.id] = true;
				}else{
					$("#"+$(el.target).parent()[0].value).hide();
					toolChoice[btn.id] = false;
				}
				localStorage.setItem("planinnsyn-toolChoice", JSON.stringify(toolChoice));
			};
			sideBtn.appendChild(toolCheckbox);
			btn.appendChild(icon);
			$(".map-toolbar, collapsible").prepend(btn);
			$(".map-toolbar-side, collapsible").prepend(sideBtn);
			let storedChoice = JSON.parse(localStorage.getItem("planinnsyn-toolChoice"));
			if(storedChoice){
				if(typeof storedChoice[btn.id] !== 'undefined'){
					toolCheckbox.checked = storedChoice[btn.id];
					if(!storedChoice[btn.id]){
						$("#"+btn.id).hide();
					}
				}else{
					toolCheckbox.checked = true;
					toolChoice[btn.id] = true;
					localStorage.setItem("planinnsyn-toolChoice", JSON.stringify(toolChoice));
				}
			}else{
				toolCheckbox.checked = true;
				toolChoice[btn.id] = true;
				localStorage.setItem("planinnsyn-toolChoice", JSON.stringify(toolChoice));
			}				
		}
	},
	getMeasureLength: function (feature) {
		var size = feature.getGeometry().getLength();
		var distance = 0;
		if (size > 10000) {
			distance = (Math.round(size / 1000 * 100) / 100) + " " + "km";
		} else {
			distance = Math.round(size) + " " + "m";
		}
		return distance;
	},
	getMeasureArea: function (feature) {
		var size = feature.getGeometry().getArea();
		var area = 0;
		if (size > 1000000) {
			area = (Math.round(size / 1000000 * 100) / 100) + " km²";
		} else {
			area = Math.round(size) + " " + "m²";
		}
		return area;
	},
};
privateFns = {
	deactivateMapTools: function(func){
		return func;
	},
	createToolHelp: function(tool){
		if(!localStorage.getItem("planinnsyn-" + tool.id)){				
			var help, button, icon, header, heading, list, okWrapper, okButton, inputWrapper, hideTip, hideTipLabel;
			help = creator.createDiv({css: "measure-tool-help", id: tool.toolHelp.id});
			
			header = creator.createHeader({});
			button = creator.createButton({
				onclick: function(){
					$("#"+tool.toolHelp.id).hide();
				}
			});
			icon = creator.createIcon({css: "icon-Close"});
			button.appendChild(icon);
			header.appendChild(button);
			help.appendChild(header);
			
			heading = creator.createH4({text: tool.toolHelp.header});
			help.appendChild(heading);
			list = creator.createOl({});
			tool.toolHelp.steps.forEach(function(item){
				list.appendChild(creator.createLi({text: item}));
			});
			help.appendChild(list);
			okWrapper = creator.createDiv({css: "tip-win-btn-wrapper"});
			okButton = creator.createButton({
				css: "btn btn-default", 
				text: "OK", 
				onclick: function(){
				localStorage.setItem("planinnsyn-" + tool.id, $("#"+tool.toolHelp.id+"hideTip").is(':checked'));
					$("#"+tool.toolHelp.id).hide();
				}
			});
			okWrapper.appendChild(okButton);
			help.appendChild(okWrapper);
			
			inputWrapper = creator.createDiv({css: "tip-win-input-wrapper"});
			hideTip = creator.createInput({type: "checkbox", id: tool.toolHelp.id + "hideTip"});
			hideTipLabel = creator.createLabel({labelfor: tool.toolHelp.id, text: "Ikke vis igjen"});
			inputWrapper.appendChild(hideTip);
			inputWrapper.appendChild(hideTipLabel);
			help.appendChild(inputWrapper);
			
			$("#map")[0].appendChild(help);
		}
	},
	showPosition: function (pos) {
		var btn = $("#go-to-location");
		var geoLocLayer = global.map.getLayerById("geoloclayer");
		var coords = [pos.coords.longitude, pos.coords.latitude];
		var transCoords = ol.proj.transform(
			coords,
			"EPSG:4326",
			"EPSG:32632"
		);
		global.map.getView().setCenter(transCoords);
		var feature = new ol.Feature({
			name: "myPosition",
			geometry: new ol.geom.Point(transCoords),
		});
		geoLocLayer.getSource().addFeature(feature);
		btn.removeClass("map-tool-btn-busy");
		btn.prop("disabled", false);
		btn.find("i").addClass("fa-crosshairs").removeClass("fa-spinner fa-pulse");
	},
	showError: function (error) {
		var btn = $("#go-to-location");
		btn.addClass("map-btn-disabled").removeClass("map-tool-btn-busy");
		btn.prop("disabled", true);
		btn.find("i").addClass("fa-crosshairs").removeClass("fa-spinner fa-pulse");
		switch (error.code) {
			case error.PERMISSION_DENIED:
			alert("Stedsangivelse er ikke aktivert. Sjekk innstillinger for din nettleser.");
			btn.prop("title", "Permission denied");
			break;
			case error.POSITION_UNAVAILABLE:
			alert("Stedsangivelse er ikke tilgjengelig for din nettleser eller enhet.");
			btn.prop("title", "Location information unavailable");
			break;
			case error.TIMEOUT:
			btn.prop("title", "Location timed out");
			alert("Beklager, det tok for lang tid å hente din posisjon. Hvis du vil prøve igjen kan du laste inn siden på nytt.");
			break;
			default:
			console.log("?: " + error);
		}
	},
	createOLOverrides: function () {
		if (Map.prototype.getLayerByName === undefined) {
			Map.prototype.getLayerByName = function (name) {
				var layer = null;
				this.getLayers().forEach(
					/**
					* @param lyr
					* @param lyr.get
					* @param lyr.getLayers
					*/
					function (lyr) {
						if (name === lyr.get("title")) {
							layer = lyr;
						} else if (lyr.getLayers) {
							lyr.getLayers().forEach(function (sublyr) {
								if (name === sublyr.get("title")) {
									layer = sublyr;
								} else if (sublyr.getLayers) {
									sublyr.getLayers().forEach(function (subsublyr) {
										if (name === subsublyr.get("title")) {
											layer = subsublyr;
										}
									});
								}
							});
						}
					}
				);
				return layer;
			};
		}

		if (Map.prototype.getLayerById === undefined) {
			Map.prototype.getLayerById = function (name) {
				var layer = null, recursiveFn;
				/**
				* @param lyr
				* @param lyr.get
				* @param lyr.getLayers
				*/
				recursiveFn = function (lyr) {
					if (name === lyr.get("layerId")) {
						layer = lyr;
					} else if (lyr.getLayers) {
						lyr.getLayers().forEach(function (subLyr) {
							recursiveFn(subLyr);
						});
					}
				};
				this.getLayers().forEach(
					recursiveFn
				);
				return layer;
			};
		}
		if (Map.prototype.getLayersBy === undefined) {
			Map.prototype.getLayersBy = function (key, value) {
				var layers = [];
				var recursiveFn = undefined;
				/**
				* @param lyr
				* @param lyr.get
				* @param lyr.getLayers
				*/
				recursiveFn = function (lyr) {
					if (value === lyr.get(key)) {
						layers.push(lyr);
					} else if (lyr.getLayers) {
						lyr.getLayers().forEach(function (subLyr) {
							recursiveFn(subLyr);
						});
					}
				};
				this.getLayers().forEach(
					recursiveFn
				);
				return layers;
			};
		}

		if (Map.prototype.getInteractionById === undefined) {
			Map.prototype.getInteractionById = function (id) {
				var interaction = null;
				this.getInteractions().forEach(function (i) {
					if (id === i.get("interactionId")) {
						interaction = i;
					}
				});
				return interaction;
			};
		}
	},
	createStringXY2: function () {
		return function (coordinate) {
			return format(coordinate, "N: {y}, Ø: {x}");
		};
	},
	changeLayerSources: function (map) {
		global.forAllLayers(map, function (layer) {
			if (layer.get("altSource")) {
				var oldSource = layer.getSource();
				layer.setSource(layer.get("altSource"));
				layer.set("altSource", oldSource);
			}
		});
	},
	changeStyle: function(feature, resolution){
		var medinc = feature.get('medinc');

		//Iterate through the class break array
		for(var i = 0; i < breaks_color.length; i++) {
			if (medinc>=breaks_color[i][0] && medinc<breaks_color[i][1]){
				fillColor=breaks_color[i][2]
			}
		}

		style = new ol.style.Style({
			fill: new ol.style.Fill({
				color: fillColor
			}),
			stroke: new ol.style.Stroke({
				color: [0,0,0,1],
				width: 0.5
			})
		});
		return style;
	},
	createMap: function (mapElId, conf) {
		if (conf.minZoom === undefined) {
			conf.minZoom = 9;
		}
		var resolutions = global.mapresolutionsExt.slice(0, conf.minZoom + 1);

		proj4.defs([["EPSG:32632", "+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs"], ['EPSG:4326','+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees'], ['EPSG:3857','+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs'],["EPSG:3395","+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs"],["EPSG:900913","+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext +no_defs"]]);
		register(proj4);
		var localProjection = getProjection("EPSG:32632");

		var view = new View(
			{resolutions: resolutions, projection: localProjection}
		);

		var map = new Map({
			target: mapElId,
			layers: [],
			view: view,
			pixelRatio: 1,
			controls: [
				new MousePosition({target: "mouseposition", coordinateFormat: privateFns.createStringXY2(), className: "mouse-position"}),
				new ScaleLine({
					target: "scaleline",
					className: "scaleline"
				}),
				new Zoom({
					className: "zoombuttons",
					zoomInTipLabel: "Zoom inn",
					zoomOutTipLabel: "Zoom ut"
				})
			],
			interactions: defaults({
				altShiftDragRotate: false,
				pinchRotate: false
			})
		});
		map.set("oldZoom", 0);

		/**
		* Sjekker om forenklet kommunegrense vises innenfor kartutsnittet. Hvis det gjør det skal
		* topo4 vises (kart over nabokommune), hvis ikke, skal topo4 slås av.
		*/
		map.on("moveend", function (e) {
			var currentExtent = e.map.getView().calculateExtent();
			var edge = false;
		});
		if(!conf.contextMenu.disableMapClick){			
			map.getViewport().style.cursor = "pointer";
		}

		/**
		* Musepeker skal endre stil ved panorering
		*/
		map.on("pointerdrag", function () {
			$(".ol-viewport").css("cursor", "move");
		});

		/**
		* Tilbakestiller stil for musepeker etter panorering er ferdig
		*/
		map.on("pointerup", function () {
			if(!conf.contextMenu.disableMapClick){				
				$(".ol-viewport").css("cursor", "pointer");
			}else{
				$(".ol-viewport").css("cursor", "auto");
			}
		});

		/**
		* Kodesnutten under sørger for at popup følger musepeker.
		*/
		global.map = map;
		/*
		Legger til lytter til view for å eventuelt endre source for cachede kartlag når man
		zoomer lenger inn enn cache er definert
		*/
		view.on("change:resolution", function () {
			var zoom = view.getZoom();
			if (parseInt(zoom, 10) === zoom) {
				if (zoom > 9 && map.get("oldZoom") <= 9) {
					privateFns.changeLayerSources(map);
				} else if (zoom <= 9 && map.get("oldZoom") > 9) {
					privateFns.changeLayerSources(map);
				}
				map.set("oldZoom", zoom);
			}
		});

		/*
		Kobler map-objektet til domElementet som inneholder map-objektet for å kunne få
		tak i det fra plugin-script
		*/
		$("#" + mapElId).data("mapObject", map);
		privateFns.restyleZoomButtons();
		
	},
	restyleZoomButtons: function(){
		$(".zoombuttons-in")[0].innerHTML = '<i class = "icon-Plus-sign map-tool-btn-styling"></i>'
		$(".zoombuttons-out")[0].innerHTML = '<i class = "icon-Minus-sign map-tool-btn-styling"></i>'
	}
};

export default {
	initiateMap: function (mapElId, conf) {
		privateFns.createOLOverrides();

		/* Lagrer konfig i glob for å gjøre den tilgjengelig i andre filer */
		global.appConfig = conf;
 
		privateFns.createMap(mapElId, conf);
		layerAdder.addLayers(conf.baseLayers);
		layerAdder.addLayers(conf.layermenuLayers);
		
		layerAdder.addPopupOverlay();
		
		/* Legger til klikk og hoverinteraksjoner til kartet */
		//mapInteractions.addPopupCloseTrigger();
		if (conf.mapInteractions.featureHover) {
			mapInteractions.addFeatureHoverInteraction(conf.mapInteractions.featureClick, conf.contextMenu.featureHoverLayout);
		}
		if (conf.mapInteractions.featureClick) {
			mapInteractions.addFeatureClickInteraction(conf);
		}
		if (conf.mapTools.length > 0) {
			conf.mapTools.forEach(function (tool) {
				mapInteractions.addMapToolPlugin(tool);
			});
			$(".collapsible-toolbar-toggler").append(creator.createButton({
				id: "map-wrench",
				css: "map-tool-btn-coll map-wrench-btn",
				title: "Vis flere verktøy",
				ariaLabel: "Vis flere verktøy",
				icon: true,
				iconClass: "glyphicon glyphicon-wrench"
			}));
			$(".collapsible-toolbar-toggler").click(function (e) {
				var target = $(".map-toolbar-side, .collapsible");
				target.toggle();
			});
		}
		
		functionality.addMobileEvents(),
		window.addEventListener("touchstart", function () {
			global.isTouchDevice = true;
			if (global.hoverClassRemoved === false) {
				functionality.removeHoverCssClasses();
				global.hoverClassRemoved = true;
			}
		});
	},
	markerEiendom: function(teigid){
		privateFns.getEiendomPolygon(teigid);
	},
	publicAddMeasureLayer: mapInteractions.addMeasureLayer,
	publicAddDrawLayer: mapInteractions.addDrawLayer,
	
	mapInteractions: mapInteractions
};
